module.exports = __webpack_public_path__ + "img/Top.2f375e41.png";